import api from '@shared/services/api';

export const additionalAgreementsService = {
    getAdditionalAgreementById: async (id) => {
        const response = await api.get(`/hr-anex-law-reasons/${id}`);
        return response.data;
    },
    getAdditionalAgreements: async (params = {}) => {
        const queryParams = new URLSearchParams();
        
        if (params.pageNumber !== undefined)queryParams.append('page', params.pageNumber);
        if (params.pageSize !== undefined) queryParams.append('size', params.pageSize);
        if (params.sortBy) queryParams.append('sortBy', params.sortBy);
        if (params.sortDir) queryParams.append('sortOrder', params.sortDir);
        
        // Handle search query
        if (params.searchQuery && typeof params.searchQuery === 'object') {
            Object.entries(params.searchQuery).forEach(([key, value]) => {
                if (value) queryParams.append(key, value);
            });
        }
        
        // Handle active filter
        if (params.active !== undefined && params.active !== null) {
            queryParams.append('active', params.active);
        }
        
        const queryString = queryParams.toString();
        const url = `/hr-anex-law-reasons${queryString ? `?${queryString}` : ''}`;
        const response = await api.get(url);
        return response.data;
    },
    getHrNssiReasons: async () => {
        const response = await api.get('/hr-nssi-reason/1');
        return response.data;
    },
    createAdditionalAgreement: async (data) => {
        const response = await api.post('/hr-anex-law-reasons', data);
        return response.data;
    },
    updateAdditionalAgreement: async (id, data) => {
        const response = await api.put(`/hr-anex-law-reasons/${id}`, data);
        return response.data;
    },
    deleteAdditionalAgreement: async (id) => {
        const response = await api.delete(`/hr-anex-law-reasons/${id}`);
        return response.data;
    },
    getTranslation: async (id) => {
        const response = await api.get(`/hr-anex-law-reasons/translation/${id}`);
        return response.data;
    },
    saveTranslation: async (data) => {
        const response = await api.post('/hr-anex-law-reasons/translate', data);
        return response.data;
    },
    getAdditionalAgreementsReportData: async (params = {}) => {
        const queryParams = new URLSearchParams();
        
        // Handle search query
        if (params.searchQuery && typeof params.searchQuery === 'object') {
            Object.entries(params.searchQuery).forEach(([key, value]) => {
                if (value) queryParams.append(key, value);
            });
        }
        
        // Handle active filter
        if (params.active !== undefined && params.active !== null) {
            queryParams.append('active', params.active);
        }
        
        const queryString = queryParams.toString();
        const url = `/hr-anex-law-reasons/report${queryString ? `?${queryString}` : ''}`;
        const response = await api.get(url);
        return response.data || [];
    }
}

